// The MICRO-LABEL — the small mono uppercase caption that labels DATA: a
// sheet's section header ("ROLES"), a KPI's name, a stage lane ("LEAD"), a
// dialog's eyebrow ("PIPELINE"), a page's app name ("CRM"). DESIGN_SPEC §5.7,
// P6 (references r044 r090 r091): the `Code` face, `Y`, weight 500, tracked
// `.06em`, uppercase, the quiet `inactive` ink (6.5:1 on `gray15`, 5.4:1 on a
// dark `gray3` sheet).
//
//   AppMicroLabel: { text: '{{ crm.section.roles | polyglot }}' }
//
// A label, never a control: buttons, tabs, navigation and titles do not use
// the mono face.
//
// Uppercase is CSS, never JS: `text-transform` leaves Georgian Mkhedruli
// alone (CSS Text 3), where `toUpperCase()` would turn it into Mtavruli
// capitals (__tests__/georgianEyebrowsStayMkhedruli.test.js).
//
// It sits on sheets and pages. On a WASHED dark row (hover / selected)
// `inactive` drops to 3.3:1 — a label inside a washed row takes
// `color: 'caption'` at the call site.
export const AppMicroLabel = {
  tag: 'span',
  fontFamily: 'Code',
  fontSize: 'Y',
  fontWeight: '500',
  lineHeight: '1.4',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  // THE TEXT LAW (overflow law §3b.8): a long eyebrow (Georgian runs long)
  // wraps inside its head instead of running past a sheet's radius clip (it
  // was `nowrap`).
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  color: 'inactive'
}
